import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { useAnalytics } from '@/hooks/useAnalytics';

export const AnalyticsRoute = () => {
  const location = useLocation();
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.trackEvent('page_view', {
      page: location.pathname,
      search: location.search,
    });
  }, [location, analytics]);

  return <Outlet />;
};
